module.exports = "<h2>Quotazioni cellulari usati: {{brand?.name}}</h2>\n<app-variant-list *ngIf=\"variants\" [variants]=\"variants\"></app-variant-list>"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/brand-list/brand-list.component.html
// module id = 740
// module chunks = 1